import "./i18n/config";
import CssBaseline from "@mui/material/CssBaseline";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import * as Sentry from "@sentry/react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { AdminLayout } from "@modules/administration/AdminLayout";
import { AuthLayout } from "@modules/auth/AuthLayout";
import { appTheme } from "theme/default/somnofy";
import useFnsLocale from "hooks/useFnsLocale";

// Sentry integration
if (location.hostname !== "localhost") {
  Sentry.init({
    dsn: "https://1e6cf856b7504037a3ace15b2d2e811d@o197106.ingest.sentry.io/4504558544945152",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.01,
    environment: location.hostname,
    release: import.meta.env.VITE_GIT_SHA,
  });
}

// APP
function App() {
  const { fnsLocale } = useFnsLocale();

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={appTheme}>
        <CssBaseline>
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={fnsLocale}
          >
            <ToastContainer
              hideProgressBar
              position="bottom-right"
              autoClose={7000}
              toastClassName="toast-custom-styles"
              style={{
                width: "auto",
                right: 64,
                bottom: 24,
              }}
            />
            <Routes>
              <Route path="auth/*" element={<AuthLayout />} />
              <Route path="*" element={<AdminLayout />} />
            </Routes>
          </LocalizationProvider>
        </CssBaseline>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
